// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:21
import { TrafficIncidentsArgs_abstract } from './../abstract/SagaBase/TrafficIncidentsArgs_abstract';
export class TrafficIncidentsArgs extends TrafficIncidentsArgs_abstract {}
